import Modal from "../../components/Modal/Modal";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Icon } from "@iconify/react";

const EnterSponsorCode = () => {
  const navigate = useNavigate();
  const parentContext = useOutletContext();

  const onCloseModal = () => {
    parentContext.setAddSponsorCodeModal(false);
    navigate(-1);
  };

  const submitClickHandler = async () => {
    await parentContext.submitClickHandler();
  };

  const sponsorCodeChangeHandler = (e) => {
    parentContext.setSponsorCode(e.target.value);
    parentContext.setError("");
  };

  return (
    <Modal
      showModal={parentContext.addSponsorCodeModal}
      setModal={parentContext.setAddSponsorCodeModal}
      onCloseModal={onCloseModal}
      faddedBg={true}
    >
      <div className="modal-input">
        {/* Desktop Close Button */}
        <button
          className="modal-input__close-btn"
          onClick={onCloseModal}
          aria-label="Close"
        >
          <Icon icon="iconamoon:close" width="20" height="20" />
        </button>

        <p className="modal-input__title">
          Enter sponsor code to access the event for which you have been added as sponsor
        </p>
        <input
          type="text"
          className={`modal-input__field ${
            parentContext.error ? "modal-input__field--error" : ""
          }`}
          placeholder="Enter unique code"
          onChange={sponsorCodeChangeHandler}
          value={parentContext.sponsorCode || ""}
          maxLength={6}
        />
        {parentContext.error && (
          <p className="modal-input__error">{parentContext.error}</p>
        )}
        <p className="modal-input__helper">
          Enter the sponsor code shared with you by the organiser via email.
        </p>
        <button
          className="modal-input__btn"
          disabled={!parentContext.sponsorCode || parentContext.loading}
          onClick={submitClickHandler}
        >
          {parentContext.loading && <span className="modal-input__spinner" />}
          Continue
        </button>
      </div>
    </Modal>
  );
};

export default EnterSponsorCode;